import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Construction, Minus, X } from "lucide-react";
import "./SiteNotice.css";

const SiteNotice = () => {
  const [visible, setVisible] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  if (dismissed) return null;

  return (
    <>
      <div className="notice-wrapper">
        <AnimatePresence>
          {visible && (
            <motion.div
              className="site-notice"
              initial={{ y: 100, opacity: 0, scale: 0.9 }}
              animate={{ y: 0, opacity: 1, scale: 1 }}
              exit={{ y: 50, opacity: 0, scale: 0.9 }}
              transition={{ type: "spring", stiffness: 200, damping: 20 }}
            >
              <div className="notice-content">
                <span className="notice-icon">
                  <Construction size={24} />
                </span>
                <p>This site is being upgraded. Some sections may be incomplete.</p>
              </div>
              
              <div className="notice-actions">
                <button className="minimize-btn" onClick={() => setVisible(false)} title="Minimize">
                  <Minus size={18} />
                </button>
                <button className="close-btn" onClick={() => setDismissed(true)} title="Close permanently">
                  <X size={18} />
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <AnimatePresence>
        {!visible && (
          <motion.button
            className="reopen-btn"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            onClick={() => setVisible(true)}
            style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            <Construction size={18} /> <span className="reopen-text">Site Notice</span>
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
};

export default SiteNotice;